<template>
  <v-app>
    <Login v-if="loggedin === false" />
    <div v-if="loggedin">
      <div id="NavigationHelperBkg"></div>
      <div id="NavigationHelper__Trigger" @click="toggleNav">
        <div id="navIcon">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="NavigationHelper__Icons">
        <ul class="makaList">
          <li :title="vinogradGl">
            <router-link to="/vineyards"
              ><img src="./assets/menuIcons/vinograd.svg" alt="vinograd" />
            </router-link>
          </li>
          <li title="Podrum" v-if="vinarija">
            <router-link to="/home"
              ><img src="./assets/menuIcons/podrum.svg" alt="podrum" />
            </router-link>
          </li>
          <li title="Vina" v-if="vinarija">
            <router-link to="/wine_types"
              ><img src="./assets/menuIcons/vina.svg" alt="vina" />
            </router-link>
          </li>
          <li title="Magacin">
            <router-link to="/ware_houses"
              ><img src="./assets/menuIcons/magacin.svg" alt="magacin" />
            </router-link>
          </li>
          <li title="Katalozi"  v-if="vinarija">
            <router-link to="/catalog_info"
              ><img src="./assets/menuIcons/katalozi.svg" alt="katalozi" />
            </router-link>
          </li>

          <li title="Katalozi" v-else>
            <router-link to="/catalog_info_other"
              ><img src="./assets/menuIcons/katalozi.svg" alt="katalozi" />
            </router-link>
          </li>

          <li title="Logout" style="position: fixed; bottom: 10px">
            <img
              src="./assets/Ikone/logout-icon.svg"
              alt="katalozi"
              @click="logOut()"
            />
          </li>
        </ul>
      </div>
      <!-- /.menu-icons -->

      <div class="userProfile"></div>
      <!-- /.userProfile -->
      <Navigation
        :navItems="nav"
        :navWineItems="navPom"
        :navWareHouseItems="navMagacin"
        :navVineYardItems="navVinograd"
        :key="componentKey"
      ></Navigation>
      <div id="mainApp" @click="closeNav">
        <v-content>
          <router-view />
        </v-content>
      </div>
      <TokenComponent ref="frmtoken" />
    </div>
  </v-app>
</template>

<script>
import TokenComponent from "./components/Token";
import { serverBus } from "./main";
import { readJSON } from "./helpers/Functions";

import Login from "./views/Login";
import Navigation from "./components/Navigation";

export default {
  name: "App",
  components: {
    Login,
    Navigation,
    TokenComponent,
  },
  data() {
    return {
      nav: [],
      navPom: [],
      navMagacin: [],
      navVinograd: [],
      navOpened: false,
      fixed: "",
      loggedin: false, // Change to false to see login form
      componentKey: 1,
      init: 0,
      vinarija: true,
      vinogradGl: "Vinograd",
    };
  },
  methods: {
    daLiJeVinarija() {
      let odgovor = false;
      this.vinogradGl = "Vinograd";

      let pomStr = localStorage.getItem("isWinery");

      if (pomStr === "true") odgovor = true;
      else this.vinogradGl = "Zasad";

      return odgovor;
    },

    logOut: function () {
      localStorage.removeItem("loggedin");
      localStorage.removeItem("user-token");
      localStorage.removeItem("city");
      localStorage.removeItem("user-refresh-token");
      localStorage.removeItem("isWinery");
      localStorage.removeItem("role");
      this.loggedin = false;
      this.init = 0;

      this.$router.replace({ path: "/", redirect: "/" });
      // window.location.reload();
    },
    dajProstorije: function () {
      this.vinarija = this.daLiJeVinarija();

      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/menu/rooms", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          let _this = this;

          _this.nav = response.data;

          this.$http
            .get(this.globalServiceLocation + this.globalPort + "/menu/wine", {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            })
            .then((response) => {
              let _this = this;

              _this.navPom = response.data;

              this.$http
                .get(
                  this.globalServiceLocation +
                    this.globalPort +
                    "/vineyard/all",
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  let _this = this;

                  _this.navVinograd = response.data;

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/warehouse_type/warehouses",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;

                      _this.navMagacin = response.data;
                      _this.loggedin = true;

                      localStorage.setItem("loggedin", true);

                      this.componentKey += 1;

                      let stranica = "home";

                      if (!this.vinarija) stranica = "vineyards";

                      this.$router.push({
                        name: stranica,
                        params: {},
                      });
                    });
                });

              // this.componentKey += 1;
            });
        })
        .catch((e) => {
          if (!e.response) {
            alert(
              "Postoji problem u komunikaciji sa bazom podataka. Proverite internet vezu i/ili se obratite administratoru sistema."
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/menu/rooms",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;

                      _this.nav = response.data;

                      this.$http
                        .get(
                          this.globalServiceLocation +
                            this.globalPort +
                            "/menu/wine",
                          {
                            headers: {
                              "Content-Type": "application/json",
                              Authorization:
                                "Bearer  " + localStorage.getItem("user-token"),
                            },
                          }
                        )
                        .then((response) => {
                          let _this = this;

                          _this.navPom = response.data;

                          this.$http
                            .get(
                              this.globalServiceLocation +
                                this.globalPort +
                                "/warehouse_type/warehouses",
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              let _this = this;

                              _this.naMagacin = response.data;
                              _this.loggedin = true;

                              localStorage.setItem("loggedin", true);

                              this.componentKey += 1;
                            });
                          // _this.loggedin = true;

                          // this.componentKey += 1;
                        });
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    toggleNav: function () {
      const nav = document.getElementById("nav");
      const navIcon = document.getElementById("navIcon");
      nav.classList.toggle("open");
      navIcon.classList.toggle("open");
    },
    closeNav: function () {
      const nav = document.getElementById("nav");
      const navIcon = document.getElementById("navIcon");
      nav.classList.remove("open");
      navIcon.classList.remove("open");
    },
  },
  mounted() {
    if (localStorage.getItem("loggedin") !== null)
      if (localStorage.getItem("loggedin") === "true")
        if (this.init === 0) {
          this.loggedin = false;

          localStorage.removeItem("loggedin");
          localStorage.removeItem("user-token");
          localStorage.removeItem("city");
          localStorage.removeItem("user-refresh-token");
          localStorage.removeItem("isWinery");
          localStorage.removeItem("role");
        } else {
          this.loggedin = true;
        }
      else this.loggedin = false;
    else this.loggedin = false;

    this.init = 1;
    serverBus.$off("osvezi_meni");

    serverBus.$on("osvezi_meni", () => {
      this.dajProstorije();
    });

    // window.onbeforeunload = function (e) {

    //           var storage = window.localStorage;
    //           storage.clear()
    //       }
  },
};
</script>

<!-- Global styles -->
<style lang="scss">
.v-dialog {
  background-color: #fff;
}

.Actions__Content {
  padding: 60px 33px 20px;
}

.v-toolbar__content {
  height: auto !important;
  margin-top: 20px;
}

table.v-table tbody td {
  height: 30px;
}

table.v-table thead tr {
  height: 40px;
}

.DataTable {
  position: relative;
  // .v-datatable__actions {
  //   display: none;
  // }
  &__ButtonHolder {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 0 24px !important;
  }
  &__Button {
    width: 24px;
    height: 24px;
    margin: 0 2px;
    cursor: pointer;
  }
}

.v-textarea textarea {
  height: 65px;
}

.theme--light .v-table tbody tr:not(:last-child) {
  border-bottom: none;
}

#navIcon {
  width: 25px;
  height: 18px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  span {
    position: absolute;
    display: block;
    height: 3px;
    width: 100%;
    background: #fff;
    border-radius: 3px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
      transform-origin: left center;
    }

    &:nth-child(2) {
      top: 7px;
      transform-origin: left center;
    }

    &:nth-child(3) {
      top: 14px;
      transform-origin: left center;
    }
  }

  &.open span:nth-child(1) {
    transform: rotate(45deg);
    top: -3px;
    left: 5px;
  }

  &.open span:nth-child(2) {
    width: 0;
    opacity: 0;
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
    top: 15px;
    left: 5px;
  }
}

.application.theme--light {
  background-color: #fff;
}

.application .theme--light.v-text-field,
.theme--light .v-text-field {
  .v-input__slot {
    &:before {
      border-color: #9b9b9b;
    }
    &:hover {
      border-color: #9b9b9b;
    }
  }
}

#NavigationHelperBkg {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  padding: 11px 5px 5px;
  width: $closedNavWidth;
  color: #ffffff;
  text-align: center;
  background-color: #930022;
  z-index: 2;
  transition: background-color 0.3s ease-in-out;
  &.open {
    background-color: transparent;
  }
}

#NavigationHelper__Trigger {
  position: fixed;
  left: 14px;
  top: 10px;
  cursor: pointer;
  z-index: 101;
}

#NavigationHelper__Icons {
  position: fixed;
  left: 13px;
  top: 125px;
  z-index: 101;
  ul {
    padding: 0;
    list-style: none;
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      padding-top: 6px;
      margin-bottom: 0;
      border-bottom: 1px solid transparent;
    }
  }
}

#mainApp {
  padding-left: 50px;
  font-family: "NunitoSans", sans-serif;
}

.primary--text {
  color: #930022 !important;
}

.button {
  &--green {
    @include btn(#018389, transparent);
  }
}

.AppButtonOutlined {
  @include btn(#018389, transparent);
}

.AppButtonFilled {
  @include btn(#fff, #018389);
}

#nav {
  width: $navWidth;
  z-index: 100;
  height: 100%;
  position: fixed;
  background-color: #930022;
  transition: transform 0.3s ease-in-out;
  transform: translate3d(-200px, 0, 0);
  &.open {
    transform: translate3d(0, 0, 0);
  }
  .mm-menu_theme-dark {
    color: #ffffff;
  }
  .mm-btn_next:after {
    border-color: #fff;
  }

  .mm-panels {
    left: 0;
    > .mm-panel {
      padding: 40px 0 0;
      > .mm-navbar + .mm-listview {
        margin-top: 65px;
        width: 220px;
      }
    }
  }

  .mm-counter,
  .mm-navbar__title {
    color: #fff;
  }
  .mm-navbar {
    padding: 0;
    height: auto;
    .siteTitle {
      color: #ffffff;
      padding-top: 55px;
      margin: 0;
      font-weight: 800;
      font-family: "Nunito Sans", sans-serif;
      font-size: 36px;
    }
    .mm-navbar__title {
      font-size: 16px;
    }
  }
  .mm-navbar__btn:first-child {
    top: auto;
    bottom: 0;
  }
  .mm-iconbar {
    top: 125px;
    width: 45px;
    color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    i {
      cursor: pointer;
    }
  }
  .mm-iconbar__top {
    font-size: 20px;
  }
  .mm-menu a {
    color: #fff;
  }
  .mm-listitem > a {
    margin-right: 0;
    padding-left: 73px;
    width: 220px;
  }
  .mm-counter {
    right: 38px;
  }
  .mm-btn_next {
    &:before {
      display: none;
    }
    &:after {
      font-size: 12px;
      right: 28px;
    }
  }
  .mm-btn_next:after,
  .mm-btn_prev:before {
    border-top: 1px solid #fff;
    border-left: 1px solid #fff;
    width: 6px;
    height: 6px;
  }
}

//Globals
img {
  max-width: 100%;
}

.ModalInModal {
  max-width: 900px;
}

.ModalInModalVisi {
  max-width: 1185px;
  max-height: 95% !important;
}

.ModalAlert {
  max-width: 450px;
}

.ModalInModalMali {
  max-width: 600px;
}
.ModalInModalMaliPrijemVina {
  max-width: 500px;
}

.ModalInModalSrednji {
  max-width: 1000px;
}

.ModalInModalMaksimalaVelicina {
  max-width: 70% !important;
  max-height: 100% !important;
  // width: 100% !important;
  margin-left: 55px !important;
  margin-right: 0px !important;
  padding: 0px !important;
}

.ModalInModalMaksimalaVelicinaBerba {
  max-width: 1050px;
  max-height: 100% !important;
  // height: 100% !important;
  // width: 100% !important;
  margin-left: 55px !important;
  margin-right: 0px !important;
  padding: 0px !important;
}

.ModalInModalMaksimalaVelicinaBerbaNovo {
  max-width: 1000px !important;
  max-height: 800px !important;
  margin: 0px !important;
  padding: 0px !important;
}

.ModalInModalGrafic {
  max-width: 1200px;
  max-height: 900px;
}
.ModalInModalVineyardRows {
  max-width: 1185px;
  max-height: 100% !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.siri_modal {
  max-width: 900px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.dodavanje_merenje {
  max-width: 1000px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.maksimalna_velicina {
  max-width: 100% !important;
  max-height: 100% !important;
  height: 100% !important;
  margin-left: 55px !important;
  margin-right: 0px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.maksimalna_visina {
  max-width: 1050px;
  max-height: 100% !important;
  height: 100% !important;
  margin-left: 55px !important;
  margin-right: 0px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.dodavanje_flasiranje {
  max-width: 1100px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.siri_modal_1200 {
  max-width: 1200px !important;
}

div#Dialog.Dialog.v-dialog.v-dialog--active.siri_vinogradi {
  max-width: 1200px !important;
  @media (max-width: 1300px) {
    width: 100% !important;
    margin: 10px !important;
  }
}

div#Dialog.Dialog.v-dialog.v-dialog--active.sadnja_modal {
  max-width: 1200px !important;
  max-height: 100% !important;

  @media (max-width: 1300px) {
    width: 100% !important;
    margin: 10px !important;
  }
}

div#Dialog.Dialog.v-dialog.v-dialog--active.siri_modal_1400 {
  max-width: 1400px !important;
}

// korisceno kod datuma na WareHouseInput i na WareHouseInputBotlle da budu uzi
div.v-menu.datum {
  width: 75% !important;
}

// koristi se kod padajucih lista sa visestrukim izborom kod analitike na magacinima
div.v-select.v-select--chips {
  min-height: 2px !important;
}

div.v-select__selections {
  min-height: 2px !important;
}

div.v-menu.v-menu--inline {
  min-height: 2px !important;
}

div.v-input__slot {
  min-height: 2px !important;
}

button.v-btn.v-btn--flat.theme--light.primary--text {
  @include btn(#fff, #018389);
}

.v-table__overflow {
  overflow: visible;
}

thead {
  position: sticky;
  top: 0;
  opacity: 1;
  background-color: #fff;
  z-index: 1;
}

// i.v-icon.material-icons{
//  color: #009688!important
// }

.v-card {
  box-shadow: unset !important;
}

ul.makaList li:hover {
  transform: scale(1.3);
  transition: all 0.4s ease-in-out;
}

i.v-icon.material-icons.accent--text {
  color: #018389 !important;
}

a.mm-btn.mm-btn_prev.mm-navbar__btn {
  margin-left: 25px !important;
}
</style>
